import React from 'react'
import classnames from 'classnames'

import { IconButton } from '@st-operations/uikit/src/v2/index.js'

import AudienceLink from './audience-link'
import { prettyField } from '../collections'
import { formatChangeValue } from '../lib/operations'

const AudienceDiff = ({ audience, changes, href, excluded, onToggleExclude }) => (
  <div className={classnames('audience-diff', { 'audience-diff--excluded': excluded })}>
    <div className="audience-diff__header">
      <AudienceLink
        className="audience-diff__title"
        href={href}
        name={audience.name}
        id={audience._id}
      />
      <If condition={onToggleExclude}>
        <IconButton
          onClick={() => onToggleExclude(audience._id)}
          aria-label={excluded ? 'Add audience back to the bulk update' : 'Remove audience from the bulk update'}
          title={excluded ? 'Add back to the bulk update' : 'Remove from the bulk update'}
          iconProps={{
            icon: excluded ? 'add' : 'delete',
            type: 'fill',
            width: 16,
            height: 16,
            color: excluded ? '#13682B' : '#C0392B',
          }}
        />
      </If>
    </div>
    <Choose>
      <When condition={Object.keys(changes).length === 0}>
        <p className="audience-diff__no-changes">No changes for this audience.</p>
      </When>
      <Otherwise>
        <table className="audience-diff__table">
          <tbody>
            <For each="entry" of={Object.entries(changes)}>
              <tr key={entry[0]}>
                <th className="audience-diff__field">{prettyField(entry[0])}</th>
                <td className="audience-diff__from">{formatChangeValue(entry[1].from)}</td>
                <td className="audience-diff__arrow">→</td>
                <td className="audience-diff__to">{formatChangeValue(entry[1].to)}</td>
              </tr>
            </For>
          </tbody>
        </table>
      </Otherwise>
    </Choose>
  </div>
)

export default AudienceDiff
